export default __webpack_public_path__ + "static/media/pantry1-afterI-2048w.5041e320.avif";